import { render, staticRenderFns } from "./EntregaDestinoInfo.vue?vue&type=template&id=335da4c3"
import script from "./EntregaDestinoInfo.vue?vue&type=script&lang=js"
export * from "./EntregaDestinoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports